/**
 * @typedef {Object} PersistenceAPI
 * @property {function(): Promise<void>} init
 * @property {function(number|string|array): Promise<any>} get
 * @property {function(Object = null): Promise<any>} getAll
 * @property {function(Object): Promise<Object>} put
 * @property {function(number|string|array): Promise<any>} delete
 * @property {function(Object = null): Promise<any>} deleteAll
 * @property {function(Object = null): Promise<any>} clean
 */
export default Object.create({}, {
  init: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  get: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  getAll: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  put: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  delete: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  deleteAll: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
  clean: {
    value: () => {},
    enumerable: true,
    iterable: true,
  },
})
